export enum TagType {
    Android,
    Windows,
    Multimedia,
    Development,
    Lifestyle,
    Work,
    Administration,
    AndroidStudio,
    MacOS,
    _3DPrinting,
}
